module.exports = __webpack_public_path__ + "static/media/carrots-powerups.7307eda6.png";